export const socialsData = {
  github: 'https://github.com/HirenDhadhal',
  linkedIn: 'https://www.linkedin.com/in/hiren-dhadhal/',
  leetcode: 'https://leetcode.com/Ignite_99/',
  codeforces: 'https://codeforces.com/profile/Ignite_99',
};
